/**
 * taskAssignee — resolve a task's assignee uuid to a display label.
 *
 * `tasks.assigned_to` is FK'd to auth.users (Convention 34 — it can't be
 * PostgREST-embedded), so the name is resolved client-side from a profiles
 * id→full_name map (RLS-filtered: an admin sees every profile, other roles see
 * only their own). Falls back to a short id when the name isn't resolvable
 * (a non-admin viewing another user's task) and '—' when unassigned.
 *
 * Fixes D-F9: the Tasks Assignee cell renderer previously returned '—' on both
 * ternary branches, so the column was permanently blank regardless of assignment.
 */
export function resolveAssigneeLabel(
  assignedTo: string | null,
  namesById: Record<string, string>
): string {
  if (!assignedTo) return '—';
  return namesById[assignedTo] ?? assignedTo.slice(0, 8);
}
